import { __exports as e } from "../../../_virtual/isFloat.js";
import { a } from "./util/assertString.js";
import "./alpha.js";
import { __exports as t } from "../../../_virtual/alpha.js";
Object.defineProperty(e, "__esModule", {
  value: !0
}), e.default = function (e, a) {
  (0, r.default)(e), a = a || {};
  var l = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(a.locale ? t.decimal[a.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if ("" === e || "." === e || "-" === e || "+" === e) return !1;
  var o = parseFloat(e.replace(",", "."));
  return l.test(e) && (!a.hasOwnProperty("min") || o >= a.min) && (!a.hasOwnProperty("max") || o <= a.max) && (!a.hasOwnProperty("lt") || o < a.lt) && (!a.hasOwnProperty("gt") || o > a.gt);
}, e.locales = void 0;
var r = a && a.__esModule ? a : {
    default: a
  },
  l = Object.keys(t.decimal);
e.locales = l;